import { render, staticRenderFns } from "./XmlBankaHesabiSec.vue?vue&type=template&id=112f58d6"
import script from "./XmlBankaHesabiSec.vue?vue&type=script&lang=ts"
export * from "./XmlBankaHesabiSec.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports